export class OverrideDataClassificationsRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "dataClasses",
            "baseName": "dataClasses",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return OverrideDataClassificationsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
